import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./AuthContext";
import { AppStateProvider } from "./AppStateContext";
import Login from "./Login";
import Account from "./Account";
import Classes from "./Classes";
import Class from "./Class";
import ClassStudent from "./ClassStudent";
import Students from "./Students";
import Layout from "./Layout";

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginWithRedirect />} />
          <Route
            path="/*"
            element={
              <RequireAuth>
                <AppStateProvider>
                  <Layout>
                    <Routes>
                      <Route path="/*" element={<Navigate to="/classes" replace />} />
                      <Route path="/account" element={<Account />} />
                      <Route path="/classes" element={<Classes />} />
                      <Route path="/classes/:classId" element={<Class />} />
                      <Route path="/classes/:classId/students/:studentId" element={<ClassStudent />} />
                      <Route path="/students" element={<Students />} />
                    </Routes>
                  </Layout>
                </AppStateProvider>
              </RequireAuth>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

const LoginWithRedirect = () => {
  const { currentUser } = useAuth();
  return currentUser ? <Navigate to="/classes" replace /> : <Login />;
};

// Guards every route except /login, so individual pages never need their own
// logged-in check.
const RequireAuth = ({ children }) => {
  const { currentUser } = useAuth();
  return currentUser ? children : <Navigate to="/login" replace />;
};

export default App;
